import LoadingIndicator from 'components/common/LoadingIndicator';
import React from 'react';

function AsyncActionLabel({ label, fetchingLabel, isFetching }) {
  return isFetching ? <LoadingIndicator>{fetchingLabel}</LoadingIndicator> : label;
}

export default AsyncActionLabel;
